module.exports = __webpack_public_path__ + "img/wx-group.cd3f3aea.png";